// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.charts-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6%;
}

.chart {
  background-color: #fff;
  padding: 25px;
  margin-bottom: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out;
  width: 46%;
  max-height: fit-content;
}

.chart:hover {
  transform: translateY(-5px);
}

.empty-state-message {
  text-align: center;
  margin-top: 50px;
}

.empty-state-message img {
  max-width: 800px;
  width: 100%;
  height: auto;
}

.edit-modal {
  position: fixed;
  top: 10%;
  left: 60%;
  transform: translateX(-50%);
  background: #e4e4e4;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(182, 182, 182, 0.9);
  max-height: calc(100vh - 150px);
  width: 90%;
  max-width: 600px;
  overflow-y: auto;
  z-index: 9999;
}

.edit-section {
  margin-bottom: 15px;
  padding: 10px;
}

@media (max-width: 768px) {
  .empty-state-message img {
    max-width: 90%;
  }

  .chart {
      width: 100%; 
      margin-bottom: 1rem;
  }

  .chart.lineChart {
    width: 100%;
    height: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NewDashboard/NewDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,OAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,sCAAsC;EACtC,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,+CAA+C;EAC/C,+BAA+B;EAC/B,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;MACI,WAAW;MACX,mBAAmB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".charts-container {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 6%;\n}\n\n.chart {\n  background-color: #fff;\n  padding: 25px;\n  margin-bottom: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease-in-out;\n  width: 46%;\n  max-height: fit-content;\n}\n\n.chart:hover {\n  transform: translateY(-5px);\n}\n\n.empty-state-message {\n  text-align: center;\n  margin-top: 50px;\n}\n\n.empty-state-message img {\n  max-width: 800px;\n  width: 100%;\n  height: auto;\n}\n\n.edit-modal {\n  position: fixed;\n  top: 10%;\n  left: 60%;\n  transform: translateX(-50%);\n  background: #e4e4e4;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(182, 182, 182, 0.9);\n  max-height: calc(100vh - 150px);\n  width: 90%;\n  max-width: 600px;\n  overflow-y: auto;\n  z-index: 9999;\n}\n\n.edit-section {\n  margin-bottom: 15px;\n  padding: 10px;\n}\n\n@media (max-width: 768px) {\n  .empty-state-message img {\n    max-width: 90%;\n  }\n\n  .chart {\n      width: 100%; \n      margin-bottom: 1rem;\n  }\n\n  .chart.lineChart {\n    width: 100%;\n    height: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
